/**
 * 平台: cxapp 特殊处理逻辑。
 * 通用能力:
 * follow fusion.ts
 * 特殊能力：
 * 1、goTo
 */
import { PassengerJump } from './goTo';
import { bridge } from '../../index';
import { buildUrl } from '@didi/webx-js-core';
class CappJump extends PassengerJump {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    scheme(scheme) {
        bridge.openPage({
            url: buildUrl(scheme, this.params)
        });
    }
    path(path, appId, extParams) {
        let programType = extParams && extParams.programType ? extParams.programType : 0;
        let appIdSource = this.appIdSourceMap[appId] || appId;
        let pagepath = `${/^\//.test(path) ? '' : '/'}${path}`;
        bridge.launchWeChatMiniApp({
            userName: appIdSource,
            path: buildUrl(pagepath, this.params),
            miniprogramType: programType
        });
    }
}
function commonJump(loadParams, xenv, commonParams = {}) {
    new CappJump(loadParams, xenv, commonParams).doJump();
}
export { commonJump as cappCommonJump };
